import { render, staticRenderFns } from "./SurveyProjectID.vue?vue&type=template&id=fc265b96&scoped=true"
import script from "./SurveyProjectID.vue?vue&type=script&lang=js"
export * from "./SurveyProjectID.vue?vue&type=script&lang=js"
import style0 from "./SurveyProjectID.vue?vue&type=style&index=0&id=fc265b96&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fc265b96",
  null
  
)

export default component.exports